// threshold to seekable range borders to disable seek permissions
export const SEEK_BACK_MARGIN = 5;
export const SEEK_FORWARD_MARGIN = 1;
export const getSafeSeekPosition = (position, seekableRange) => {
    if (position <= seekableRange.start) {
        return seekableRange.start;
    }
    if (position > seekableRange.end) {
        return seekableRange.end;
    }
    return position;
};
